const getters = {
  navShow: state => state.app.navShow,
  contactId: state => (state.app.contactInfo ? state.app.contactInfo.id : '') || '',
  // userInfo: state => state.app.userInfo,
  contactWxUserId: state => state.app.contactWxUserId,
  initAgentConfig: state => state.app.initAgentConfig,
  // robot相关getters
  selectedUserIds: state => state.robot.selectedUserIds
}
export default getters
